export default __webpack_public_path__ + "static/media/grooves.ec81ae3f.jpg";